// landing/PricingSection.jsx
import React from 'react';
import WorkspacePricingChart from './WorkspacePricingChart';

const PricingSection = ({ onSignupClick }) => {
  return (
    <section id="compare" className="relative z-10 border-t border-white/5 px-6 py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-16 text-center">
          <h2 className="mb-6 text-3xl font-bold md:text-4xl">Choose the Workspace That Fits</h2>
          <p className="mx-auto max-w-3xl text-lg text-gray-300 md:text-xl">
            Start free with 3 local workspaces, or upgrade to unlimited cloud workspaces with secure sync, persistent history, files, and context that travel with you.
          </p>
        </div>

        <WorkspacePricingChart onLocalAction={onSignupClick} onCloudAction={onSignupClick} />

        <div className="mt-12 text-center">
          <button
            onClick={onSignupClick}
            className="rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 px-8 py-3 font-medium text-white shadow-lg transition-all duration-300 hover:from-orange-600 hover:to-amber-600"
          >
            Start Free
          </button>
          <p className="mt-3 text-sm text-gray-400">3 local workspaces free. Unlimited cloud workspaces for $9/month.</p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;